import { render } from "./GoCatalogButton.vue?vue&type=template&id=541b7f09&scoped=true"
import script from "./GoCatalogButton.vue?vue&type=script&lang=js"
export * from "./GoCatalogButton.vue?vue&type=script&lang=js"

import "./GoCatalogButton.vue?vue&type=style&index=0&id=541b7f09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541b7f09"]])

export default __exports__